import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';
import { PermissionService } from './permission.service';
import { environment } from '../../../environments/environment';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const permissions = inject(PermissionService);
  const router = inject(Router);

  return auth.isLoading$.pipe(
    filter((isLoading) => !isLoading),
    take(1),
    map(() => {
      if (!permissions.isAuthenticated()) {
        auth.loginWithRedirect({ appState: { target: state.url } });
        return false;
      }

      if (!permissions.hasPermission([environment.baseAccessGroup ?? ''])) {
        return router.createUrlTree(['/forbidden']);
      }

      return true;
    }),
  );
};
